import { Component, OnInit } from '@angular/core';

import { AzureService } from '../../api/azure.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InactiveModalComponent } from '../../inactive-modal.component';

@Component({
	templateUrl: 'data-import.component.html',
	styleUrls: ['data-import.component.css']
})

export class DataImportComponent implements OnInit {
	value: any[] = [];
	constructor(private azureTest: AzureService, private modalService: NgbModal) { }

	ngOnInit() {
		// this.azureTest.getResponse().subscribe(res => console.log(res));
	}

	openModal() {
		this.modalService.open(InactiveModalComponent);
	}
}
